import React from "react";
import { ClockAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { KycStep } from "../components/KycStep";

export function ExpiredStep() {
  const { t } = useTranslation();

  return (
    <KycStep labelledBy="kyc-expired-title" className="kyc-status-step">
      <div className="flex min-h-[42dvh] flex-col items-center justify-center py-4 text-center">
        <span className="flex size-16 items-center justify-center rounded-2xl bg-slate-100 text-slate-700 ring-1 ring-slate-200">
          <ClockAlert className="size-7" aria-hidden="true" />
        </span>
        <h1
          id="kyc-expired-title"
          className="mt-7 text-[1.75rem] font-semibold leading-tight tracking-[-0.035em] text-slate-950"
        >
          {t("kyc.expired.title")}
        </h1>
        <p className="mt-3 max-w-md text-sm leading-6 text-slate-600">
          {t("kyc.expired.description")}
        </p>
      </div>
    </KycStep>
  );
}
